import { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DashboardSettings from './operational/DashboardSettings';
import DashboardDwollaWebhooks from './operational/DashboardDwollaWebhooks';
import DashboardServicesHealth from './operational/DashboardServicesHealth';
import DashboardFailedJobs from './operational/DashboardFailedJobs';
import DashboardJobs from './operational/DashboardJobs';
import DashboardSystemJobs from './operational/DashboardSystemJobs';

function DashboardOperational() {
  const [defaultDashboard, setDefaultDashboard] = useState(false);

  useEffect(() => {
    setDefaultDashboard(localStorage.getItem('dashboard') === 'operational');
  }, []);

  return (
    <>
      <Row className="align-items-start">
        <Col md={12} className="mb-4 d-flex justify-content-end align-items-center">
          <div className="d-flex">
            <Form.Check
              checked={defaultDashboard}
              onChange={() => {
                setDefaultDashboard(prev => !prev);
                if (localStorage.getItem('dashboard') === 'operational') {
                  localStorage.removeItem('dashboard');
                } else {
                  localStorage.setItem('dashboard', 'operational');
                }
              }}
            />
            <Form.Label className="p-0 m-0">Make this my default dashboard</Form.Label>
          </div>
        </Col>
      </Row>
      <Row className="align-items-start">
        <Col md={6}>
          <DashboardServicesHealth />
          <DashboardSystemJobs />
          <DashboardSettings />
          <DashboardDwollaWebhooks />
        </Col>
        <Col md={6}>
          <DashboardFailedJobs />
          <DashboardJobs />
        </Col>
      </Row>
    </>
  );
}

export default DashboardOperational;
